import { FC, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";

import RestrictedContent from "@/components/RestrictedContent";
import ScrollableTable from "@/components/ScrollableTable";
import { Td } from "@/components/Table";
import { CombinedTopicsType } from "@/types/resources";
import { numFormatter } from "@/utils/helpers";
import { RootState } from "@/utils/store";
import TopTopicsInnerTable from "./TopTopicsInnerTable";
import { ExpandButton } from "./TopTopicsTableRow";

const InnerTableTd = styled.td`
  padding: 0 !important;
`;

const TitleHolder = styled.div`
  display: flex;
`;

interface Props {
  topic: CombinedTopicsType;
  optionsKey: string;
  activeTab: number;
  filteredChannelsIds: number[];
}

const TopCombinedTopicsTableRow: FC<Props> = ({
  topic,
  optionsKey,
  activeTab,
  filteredChannelsIds,
}) => {
  const [showVideosTable, setShowVideosTable] = useState(false);

  const tableViewOptions = useSelector(
    (rootState: RootState) => rootState.options.tableViews[optionsKey]
  );

  var tableViewOptionsArray = Object.keys(tableViewOptions).map(
    (key) => tableViewOptions[key]
  );

  return (
    <>
      <tr>
        <Td>
          <TitleHolder>
            <ExpandButton
              $open={showVideosTable}
              onClick={() => setShowVideosTable((prev) => !prev)}
            >
              <svg
                width="8"
                height="6"
                viewBox="0 0 8 6"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1 1.5L4 4.5L7 1.5"
                  stroke="#4136CF"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </ExpandButton>
            {topic.title}
          </TitleHolder>
        </Td>
        {tableViewOptions["MA Rating"] && <Td>-</Td>}
        {tableViewOptions["Total views"] && (
          <Td>{numFormatter(topic.totalViews)}</Td>
        )}
        {tableViewOptions.Videos && <Td>{topic.videosCount}</Td>}
        {tableViewOptions.VPH7 && <Td>{topic.vph7 ?? "-"}</Td>}
        {tableViewOptions.VPH30 && <Td>{topic.vph30 ?? "-"}</Td>}
        {tableViewOptions["Combined VPH7"] && (
          <Td>{topic.vph7Sum ? numFormatter(topic.vph7Sum) : "-"}</Td>
        )}
        {tableViewOptions["Combined VPH30"] && (
          <Td>{topic.vph30Sum ? numFormatter(topic.vph30Sum) : "-"}</Td>
        )}
        {tableViewOptions["Average V7"] && (
          <Td>{topic.v7 ? numFormatter(topic.v7) : "-"}</Td>
        )}
        {tableViewOptions["Average V30"] && (
          <Td>{topic.v30 ? numFormatter(topic.v30) : "-"}</Td>
        )}
        {tableViewOptions.V7 && (
          <Td>{topic.v7Sum ? numFormatter(topic.v7Sum) : "-"}</Td>
        )}
        {tableViewOptions.V30 && (
          <Td>{topic.v30Sum ? numFormatter(topic.v30Sum) : "-"}</Td>
        )}
        {tableViewOptions["V7 Index"] && (
          <Td>{topic.v7Index?.toFixed(2) ?? "-"}</Td>
        )}
        {tableViewOptions["V30 Index"] && (
          <Td>{topic.v30Index?.toFixed(2) ?? "-"}</Td>
        )}
        {tableViewOptions["Virality Rate"] && (
          <Td>
            {topic.viralityRate ? `${topic.viralityRate?.toFixed(2)}%` : "-"}
          </Td>
        )}
        {tableViewOptions.RPM && (
          <Td>
            <RestrictedContent>
              {topic.rpm !== null ? `$ ${topic.rpm}` : "-"}
            </RestrictedContent>
          </Td>
        )}
        {tableViewOptions["Trending in Views"] && <Td>-</Td>}
        {tableViewOptions.Note && <Td>-</Td>}
      </tr>
      {showVideosTable && (
        <tr>
          <InnerTableTd
            colSpan={
              tableViewOptionsArray.filter((item) => item === true).length + 1
            }
          >
            <ScrollableTable>
              <TopTopicsInnerTable
                activeTab={activeTab}
                filteredChannelsIds={filteredChannelsIds}
                topics={topic.topics}
              />
            </ScrollableTable>
          </InnerTableTd>
        </tr>
      )}
    </>
  );
};

export default TopCombinedTopicsTableRow;
